import { Ico84Error } from "@/shared/assets/icons/ico_84_error";
import { Button } from "@/shared/ui/button";

interface EmailErrorProps {
  title: string;
  description: string;
  button1: {
    label: string;
    onClick: () => void;
  };
  button2: {
    label: string;
    onClick: () => void;
  };
}

export function EmailError({ title, description, button1, button2 }: EmailErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="bg-primary-100 tb:size-21 tb:mb-12 mb-6 flex size-14 items-center justify-center rounded-full">
        <Ico84Error />
      </div>
      <div className="mb-10">
        <h3 className="heading-3-bold tb:mb-3 tb:whitespace-nowrap mb-2 whitespace-pre-line text-gray-900">{title}</h3>
        <p className="body-md-regular text-gray-900">{description}</p>
      </div>

      <div className="tb:flex-row tb:max-w-[464px] tb:gap-3 flex w-full flex-col justify-center gap-4">
        <Button className="tb:flex-1 w-full" variant="line" size="lg" onClick={button1.onClick}>
          {button1.label}
        </Button>
        <Button className="tb:flex-1 w-full" variant="primary" size="lg" onClick={button2.onClick}>
          {button2.label}
        </Button>
      </div>
    </div>
  );
}
